import { Component } from '@angular/core';

@Component({
    selector: 'ms-skeleton-marquee',
    templateUrl: './skeleton-marquee.component.html',
})
export class SkeletonMarqueeComponent {}
